export const removeLineBreaks = (value?: string): string | undefined => {
  if (!value) {
    return value;
  }
  return value.replace(/\r?\n|\r/g, "");
};

export const lowerCase = (value?: string): string => {
  if (!value) {
    return "";
  }
  return value.toLowerCase();
};

export const sentenceCase = (value?: string): string => {
  if (!value) {
    return "";
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const stripBullets = (value?: string): string => {
  if (!value) {
    return "";
  }
  return value.replace(/^[•⁃-◦▪\s]$/g, "");
};

export const composeFormatters =
  (
    first: (value?: string) => string,
    ...formatters: ((value?: string) => string)[]
  ) =>
  (value?: string): string =>
    formatters.reduce((result, formatter) => formatter(result), first(value));
